/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { Dialog, CardContent, Card, IconButton } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import { useSnackbar } from "hooks/useSnackbar";
import ModelEditContext from "components/model-selector/context";
import GalleryContext from "components/model-selector/gallery/context";
import ModelDialogTopActions from "components/model-selector/dialog/actions/dialog-top-actions";
import ModelDialogBottomActions from "components/model-selector/dialog/actions/dialog-bottom-actions";
import ModelDialogPreviewPanel from "components/model-selector/dialog/panels/dialog-preview-panel";
import ModelDialogGalleryPanel from "components/model-selector/dialog/panels/dialog-gallery-panel";

const ModelSelectDialog = (props) => {

    const { showSnackbar } = useSnackbar();
    const [models, setModels] = useState();
    const searchFunction = SimpliCityAdminSDK.model.search;
    const scrollableHeight = "480px"; // '450px'
    const filter = props.filter;
    const filterValue = props.filterValue;

    const ctx = useContext(ModelEditContext);
    const { open, handleClose, selectedModel, setSelectedModel } = ctx;

    const onSelectModel = (e, model) => {
        showSnackbar("onSelectModel");
        e.stopPropagation();
        setSelectedModel(model);
    };

    const galleryCTX = {
        models,
        setModels,
        searchFunction,
        scrollableHeight,
        onSelectModel,
        selectedModel, // from edit context
        setSelectedModel, // from edit context
        showSnackbar,
        filter,
        filterValue,
    };

    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth='lg'
                className='simplicity-image-selector-overlay'
            >
                <GalleryContext.Provider value={galleryCTX}>
                    <Card elevation={0} className='simplicity-model-selector-window'>
                        <CardContent sx={{ flex: "1 0 auto", height: "100%" }}>
                            <div className='simplicity-image-selector-window-title'>
                                Model Selector
                                <IconButton onClick={handleClose} style={{ marginLeft: "auto" }}>
                                    <CloseOutlined />
                                </IconButton>
                            </div>

                            <ModelDialogTopActions />

                            <div className='simplicity-image-selector-window-content'>
                                <div className='simplicity-image-selector-window-active'>
                                    <>
                                        <ModelDialogGalleryPanel />
                                        <ModelDialogPreviewPanel />
                                    </>
                                </div>
                            </div>
                        </CardContent>
                    </Card>

                    <ModelDialogBottomActions />
                </GalleryContext.Provider>
            </Dialog>
        </Fragment>
    );
};

export default ModelSelectDialog;
